import { Typography } from "@mui/material";
import { AffirmInlineLogo } from "@/components/common/paymentPlans/affirmLogo";
import { CherryInlineLogo } from "@/components/common/paymentPlans/cherryLogo";
import PaymentPlansBannerWrapper from "@/components/common/paymentPlans/paymentPlansBannerWrapper";

export default function PaymentPlansPromotionBanner({
  cherryPromotionEnabled,
  affirmPromotionEnabled,
}: {
  cherryPromotionEnabled: boolean;
  affirmPromotionEnabled: boolean;
}) {
  if (!cherryPromotionEnabled && !affirmPromotionEnabled) return null;

  const getCopy = () => {
    const hasTwoPlansEnabled = cherryPromotionEnabled && affirmPromotionEnabled;

    if (hasTwoPlansEnabled) {
      return (
        <>
          We offer <CherryInlineLogo /> and <AffirmInlineLogo /> payment plans.
        </>
      );
    }

    return (
      <>
        We offer{" "}
        {cherryPromotionEnabled ? <CherryInlineLogo /> : <AffirmInlineLogo />}{" "}
        payment plans.
      </>
    );
  };

  return (
    <PaymentPlansBannerWrapper>
      <Typography variant="subtitleSmall">{getCopy()}</Typography>
    </PaymentPlansBannerWrapper>
  );
}
